// extracted by mini-css-extract-plugin
export default {"loading":"eigh7_loading","spin":"BTbl1_spin","loading-border":"hpRj3_loading-border"};